var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployeesIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.25 23V21.75C1.25 19.4294 2.17187 17.2038 3.81282 15.5628C5.45376 13.9219 7.67936 13 10 13C12.3206 13 14.5462 13.9219 16.1872 15.5628C17.8281 17.2038 18.75 19.4294 18.75 21.75V23",
    stroke: "#243142",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.25 15.5C16.25 13.8424 16.9085 12.2527 18.0806 11.0806C19.2527 9.90848 20.8424 9.25 22.5 9.25C23.3208 9.25 24.1335 9.41166 24.8918 9.72575C25.6501 10.0398 26.339 10.5002 26.9194 11.0806C27.4998 11.6609 27.9602 12.3499 28.2742 13.1082C28.5883 13.8665 28.75 14.6792 28.75 15.5V16.125",
    stroke: "#243142",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10 13C11.3261 13 12.5979 12.4732 13.5355 11.5355C14.4732 10.5979 15 9.32608 15 8C15 6.67392 14.4732 5.40215 13.5355 4.46447C12.5979 3.52678 11.3261 3 10 3C8.67392 3 7.40215 3.52678 6.46447 4.46447C5.52678 5.40215 5 6.67392 5 8C5 9.32608 5.52678 10.5979 6.46447 11.5355C7.40215 12.4732 8.67392 13 10 13ZM22.5 9.25C23.4946 9.25 24.4484 8.85491 25.1517 8.15165C25.8549 7.44839 26.25 6.49456 26.25 5.5C26.25 4.50544 25.8549 3.55161 25.1517 2.84835C24.4484 2.14509 23.4946 1.75 22.5 1.75C21.5054 1.75 20.5516 2.14509 19.8483 2.84835C19.1451 3.55161 18.75 4.50544 18.75 5.5C18.75 6.49456 19.1451 7.44839 19.8483 8.15165C20.5516 8.85491 21.5054 9.25 22.5 9.25Z",
    stroke: "#243142",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeesIcon);
export default __webpack_public_path__ + "static/media/employeesIcon.ec54cfbad51e3f423837265bec08f4a0.svg";
export { ForwardRef as ReactComponent };